import axios from "axios";
import { ContactFormData } from "../pages/LandingPage/contact-form-data.types";

const apiService = axios.create({
  // baseURL: "http://localhost:3000/api",
  baseURL: "https://menumaster.app.br/ws/api",
  timeout: 10000, // opcional
  headers: {
    "Content-Type": "application/json"
  }
});

apiService.interceptors.response.use(response => {
  return response;
},
  error => {
    if (!error.response) {
      console.log('error response-> ', error);
      if (error.message === 'Network Error') {
        // SEND TOAST WITH GENERIC TEXT "Erro de conexão ao servidor"
      }
      return Promise.reject(error);
    }
    if (error.response.status === 400) {
      // SEND TOAST WITH MESSAGE RECEIVED FROM API
      // error.response.data.message
    }
    if (error.response.data) {
      return Promise.reject(error.response.data);
    }
    return Promise.reject(error);
  })

export const sendContactForm = async (formData: ContactFormData) => {
  try {
    const response = await apiService.post("/contact", formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default apiService;
